
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.504 37.5h-8.49c-3.145 0-4.718 0-5.05-.244-.371-.275-.462-.437-.502-.897-.036-.41.928-1.988 2.856-5.143C8.31 27.96 10 23.216 10 16.5c0-3.713 1.58-7.274 4.393-9.9C17.206 3.976 21.021 2.5 25 2.5c3.978 0 7.793 1.475 10.606 4.1C38.42 9.226 40 12.788 40 16.5c0 6.715 1.69 11.459 3.681 14.716 1.928 3.155 2.893 4.733 2.857 5.143-.04.46-.131.622-.503.897-.331.244-1.904.244-5.05.244H32.5m-14.996 0L17.5 40a7.5 7.5 0 1015 0v-2.5m-14.996 0H32.5","stroke":"#fff","stroke-width":"5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    